export const aciNewAccount = {
    iconName: 'new-account',
    iconData: [
        128,
        128,
        `M58.244 49.739c12.702 0 22.999-10.409 22.999-23.274 0-12.827-10.297-23.286-22.999-23.286-12.666 0-22.975 10.459-22.975 23.286.001 12.865 10.31 23.274 22.975 23.274zm42.782 25.343c-3.665-1.926-7.778-3.116-12.21-3.116-14.604 0-26.435 11.83-26.435 26.428 0 2.406.425 4.693 1.029 6.906 3.048 11.225 13.207 19.521 25.405 19.521 14.604 0 26.428-11.83 26.428-26.428.001-10.165-5.802-18.886-14.217-23.311zM105 103H94v12h-9v-12H73v-9h12V83h9v11h11v9zM88.816 65.583c.878 0 1.752.087 2.624.162-7.916-4.744-18.475-6.371-31.252-6.371C30.819 59.375 12.756 67 12.756 105h44.142c-.562-2-.898-4.545-.898-6.756 0-18.094 14.723-32.661 32.816-32.661z`,
    ],
};
